module.exports = __webpack_public_path__ + "76cfd29c392148939655924691476202.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-23.png
// module id = 2165
// module chunks = 0